import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';

const TransactionNotes = (props) => {
  const { transactionNotes, } = props;
  const model = Grid.toModelFromList(transactionNotes, {
    headerFormatter: value => _.startCase(value.header),
  });
  return (
    <FieldSet title="Transaction Notes">
      <Grid headers={model.headers} rows={model.format(transactionNotes)} />
    </FieldSet>
  );
};

TransactionNotes.propTypes = {
  transactionNotes: PropTypes.array.isRequired,
};

export default TransactionNotes;
